import { Box, Tabs, Tab } from '@mui/material';
import { useTheme } from '@mui/material';
import { useEvent } from '../context/useEvent';
import { PageHeader } from '../components/EventList/PageHeader';
import { EventTable } from '../components/EventList/EventTable';
import { EventFilters } from '../components/EventList/EventFilters';
import { ErrorSnackbar } from '../components/EventList/ErrorSnackbar';
import { useNavigate } from 'react-router-dom';
import { DuplicateConfirmModal } from '../components/EventList/DuplicateConfirmModal';
import { eventService } from '../../../shared/services/tenant/eventService';
import { useState, useEffect } from 'react';

export default function EventListPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { 
    events, 
    isLoading, 
    error, 
    page,
    limit,
    total,
    setPage,
    setLimit,
    setError,
    fetchEvents,
    filters,
    setFilters,
    clearFilters
  } = useEvent();

  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<{ id?: string } | null>(null);
  const [activeTab, setActiveTab] = useState(filters.archived ? 1 : 0);

  useEffect(() => {
    const isArchived = filters.archived === true;
    setActiveTab(isArchived ? 1 : 0);
  }, [filters.archived]);

  const handleCloseError = () => setError(null);
  const handleView = (event: { id?: string }) => {
    if (event.id) {
      navigate(`/events/${event.id}`);
    } else {
      console.error('Event ID is undefined');
    }
  };

  const handleDuplicate = (event: { id?: string }) => {
    setSelectedEvent(event);
    setDuplicateModalOpen(true);
  };

  const handleConfirmDuplicate = async () => {
    if (selectedEvent?.id) {
      try {
        await eventService.duplicate(selectedEvent.id);
        setDuplicateModalOpen(false);
        setSelectedEvent(null);
        fetchEvents();
      } catch (err) {
        setError('Erro ao duplicar evento');
      }
    }
  };


  const handleCreate = () => {
    navigate('/events/new');
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    const isArchived = newValue === 1;
    const { archived, ...otherFilters } = filters;
    const newFilters = { ...otherFilters, archived: isArchived };
    setFilters(newFilters);
  };

  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />
      <DuplicateConfirmModal
        open={duplicateModalOpen}
        onClose={() => setDuplicateModalOpen(false)}
        onConfirm={handleConfirmDuplicate}
      />
      <Box style={{ 
        background: theme.palette.background.paper, 
        borderRadius: 16, 
        padding: 32, 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
        maxWidth: '100%', 
        margin: '0 auto' 
      }}>
        <PageHeader onCreate={handleCreate} isLoading={isLoading} />
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange} 
          sx={{ mb: 3 }}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Ativos" />
          <Tab label="Arquivados" />
        </Tabs>
        <EventFilters
          filters={filters}
          onFiltersChange={(newFilters) => {
            const { archived, ...otherFilters } = newFilters;
            setFilters({ ...otherFilters, archived: activeTab === 1 });
          }}
          onClearFilters={() => {
            setFilters({ archived: activeTab === 1 });
          }}
        />
        <EventTable
          events={events}
          isLoading={isLoading}
          onView={handleView}
          page={page}
          limit={limit}
          total={total}
          onPageChange={setPage}
          onPageSizeChange={setLimit}
          onDuplicate={handleDuplicate}
          isArchived={activeTab === 1}
          onRefresh={fetchEvents}
        />
      </Box>
    </>
  );
}